import { render, staticRenderFns } from "./DecisionParametersTab.vue?vue&type=template&id=730a92da&"
import script from "./DecisionParametersTab.vue?vue&type=script&lang=js&"
export * from "./DecisionParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports